import { useState, useMemo } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Smile } from 'lucide-react';

// Sprint 66 — Social Studio: curado a mano (no se agregó una librería de
// emoji nueva al bundle) — cubre las categorías más usadas en copy de
// redes sociales. Búsqueda por palabra clave en español/inglés.
const EMOJI_CATALOG = {
  'Caritas': [
    ['😀', 'feliz sonrisa'], ['😄', 'feliz risa'], ['😁', 'feliz'], ['😂', 'risa lagrimas'], ['🥰', 'amor enamorado'],
    ['😍', 'ojos corazon'], ['😎', 'lentes cool'], ['🤩', 'estrellas wow'], ['😉', 'guiño'], ['😊', 'sonrisa'],
    ['🙌', 'manos celebrar'], ['👏', 'aplauso'], ['🙏', 'gracias oracion'], ['💪', 'fuerza'], ['🔥', 'fuego tendencia'],
  ],
  'Corazones': [
    ['❤️', 'corazon rojo amor'], ['🧡', 'corazon naranja'], ['💛', 'corazon amarillo'], ['💚', 'corazon verde'],
    ['💙', 'corazon azul'], ['💜', 'corazon morado'], ['🖤', 'corazon negro'], ['🤍', 'corazon blanco'], ['💖', 'corazon brillante'],
  ],
  'Negocio': [
    ['✨', 'brillo destacar'], ['🎉', 'fiesta celebracion'], ['🎁', 'regalo promocion'], ['🏆', 'trofeo ganador'],
    ['📈', 'grafica crecimiento'], ['💰', 'dinero'], ['💳', 'tarjeta pago'], ['🛍️', 'compras'], ['⭐', 'estrella calidad'],
    ['✅', 'check listo'], ['👉', 'apuntar cta'], ['📅', 'calendario fecha'], ['⏰', 'reloj tiempo'], ['📍', 'ubicacion pin'],
  ],
  'Comida': [
    ['🍕', 'pizza'], ['🍔', 'hamburguesa'], ['☕', 'cafe'], ['🍰', 'pastel'], ['🥗', 'ensalada'], ['🍷', 'vino'],
  ],
  'Objetos': [
    ['📱', 'celular'], ['💻', 'laptop'], ['📸', 'camara foto'], ['🎬', 'video'], ['🎵', 'musica'], ['💡', 'idea'],
  ],
};

export default function EmojiPicker({ onSelect }) {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);

  const filtered = useMemo(() => {
    if (!search.trim()) return EMOJI_CATALOG;
    const q = search.trim().toLowerCase();
    const out = {};
    for (const [cat, items] of Object.entries(EMOJI_CATALOG)) {
      const matches = items.filter(([, kw]) => kw.includes(q));
      if (matches.length) out[cat] = matches;
    }
    return out;
  }, [search]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" size="sm" className="gap-1.5" data-testid="emoji-picker-trigger">
          <Smile className="w-3.5 h-3.5" /> Emoji
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-2" align="start">
        <Input
          placeholder="Buscar emoji..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="h-8 text-xs mb-2"
          data-testid="emoji-search"
        />
        <div className="max-h-64 overflow-y-auto space-y-2">
          {Object.entries(filtered).map(([cat, items]) => (
            <div key={cat}>
              <p className="text-[10px] font-medium text-[#94A3B8] mb-1">{cat}</p>
              <div className="grid grid-cols-8 gap-0.5">
                {items.map(([emoji, kw]) => (
                  <button
                    key={emoji}
                    type="button"
                    title={kw}
                    onClick={() => { onSelect(emoji); setOpen(false); }}
                    className="text-lg hover:bg-[#F1F5F9] rounded p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F72585]"
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          ))}
          {Object.keys(filtered).length === 0 && (
            <p className="text-xs text-[#94A3B8] text-center py-4">Sin resultados</p>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
